import React from 'react';


const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__content">Developed by Oleg Dudkin</p>
    </footer>
  );
};

export default Footer;